import { combineReducers } from 'redux'
import {
  reducer as faqDrawerReducer,
  FaqDrawerState,
} from '../common/modules/faqDrawer/reducer'

import { crmSelectorReducer } from '../common/modules/onboarding/crmSelector/reducer'

import { CRMListState } from '../common/modules/onboarding/crmSelector/action'

import {
  reducer as AlertReducer,
  AppAlertState,
} from '../common/modules/appAlert/reducer'

import {
  CRMAuthReducer,
  CRMAuthState,
} from '../common/modules/onboarding/crmAuth/reducer'
import {
  reducer as chartReducer,
  DashBoardChartsState,
} from '../oppsync/modules/dashboard/reducer'

import {
  AccountDataState,
  PartnerReducer,
} from '../common/modules/partner/reducer'
import {
  reducer as CrmAceMappingReducer,
  CrmAceMappingState,
} from '../common/modules/onboarding/CrmAceMapping/reducer'

import {
  reducer as AllPartnersReducer,
  AllPartnerState,
} from '../common/modules/allPartners/reducer'
import {
  reducer as UserListReducer,
  UserListState,
} from '../oppsync/modules/userList/reducer'
import { reducerTypeWrapper } from '../common/utils/actionTypeWrapper'
import { validateReducer } from '../common/modules/onboarding/validate/reducer'
import { Validate } from '../common/modules/onboarding/validate/action'
import {
  SyncHistoryReducer,
  SyncHistoryState,
} from '../oppsync/modules/syncHistory/reducer'

import {
  reducer as SupportFormReducer,
  SupportFormState,
} from '../common/modules/onboarding/supportForm/reducer'
import {
  reducer as PartnerStatsReducer,
  PartnerObjectsStatsState,
} from '../oppsync/modules/salesPipeline/partnerStats/reducer'

import {
  reducer as PartnerObjectsReducer,
  PartnerObjectsState,
} from '../oppsync/modules/salesPipeline/partnerObjects/reducer'
import {
  UserProfileReducer,
  UserProfileState,
} from '../common/modules/userProfile/reducer'
import {
  AuthorizationReducer,
  AuthorizationState,
} from '../common/modules/authorization/reducer'
import {
  SubscriptionReducer,
  SubscriptionState,
} from '../oppsync/modules/subscription/reducer'
import { defaultValueValidationReducer } from '../common/modules/onboarding/defaultValueValidation/reducer'
import { DefaultValueState } from '../common/modules/onboarding/defaultValueValidation/action'
import {
  SyncReportReducer,
  SyncReportState,
} from '../admin/modules/syncReport/reducer'
import { onboardingVerificationReducer } from '../admin/modules/onboardingVerification/reducer'
import type { OnboardingVerificationState } from '../admin/modules/onboardingVerification/types'
import {
  reducer as SavedReducer,
  SavedStatus,
} from '../common/modules/savedStatus/reducer'
import {
  reducer as SyncObjectReducer,
  SyncObjectState,
} from '../oppsync/modules/salesPipeline/syncObject/reducer'
import {
  reducer as RuleDefinition,
  RuleDefinitionMappingState,
} from '../common/modules/onboarding/ruleDefinitions/reducer'
import {
  reducer as AddUsersReducer,
  AddNewUsersState,
  zeroValueAddUserForm,
  UserType,
} from '../common/modules/AddUserForm/reducer'
import {
  reducer as CrmTablesReducer,
  CrmTableState,
} from '../common/modules/onboarding/crmTables/reducer'
import {
  CRMSchemaState,
  CRMSchemaReducer,
} from '../common/modules/onboarding/crmSchema/reducer'
import {
  CrmFieldReducerState,
  reducer as CrmFieldReducer,
} from '../common/modules/onboarding/CrmFields/reducer'
import {
  reducer as CRMTableFieldsLoading,
  CRMTableFieldLoadingState,
} from '../common/modules/onboarding/crmFieldsLoading/reducer'
import {
  reducer as NotificationSidePanelReducer,
  NotificationPanelState,
} from '../oppsync/modules/notification/notificationSidePanel/reducer'

import {
  reducer as NotificationsReducer,
  NotificationsState,
} from '../oppsync/modules/notification/reducer'
import {
  reducer as WarningStatusReducer,
  WarningState,
} from '../common/modules/onboarding/warningStatus/reducer'

import {
  reducer as ProductsListingReducer,
  ProductsListingState,
} from '../flyout/modules/productsListing/reducer'

import {
  reducer as AccountsReducer,
  CmcmAccountState,
} from '../common/modules/cmcm/accounts/reducer'

import {
  AccountsState,
  reducer as AccountsStateReducer,
} from '../oppsync/modules/productAccount/reducer'

import {
  reducer as PrivateOffersReducer,
  PrivateOffersState,
} from '../flyout/modules/privateOffer/reducer'
import {
  reducer as CPPOAdminReducer,
  ResaleAuthorizationsState,
} from '../admin/modules/resaleAuthorizations/reducer'
import {
  reducer as CustomFormReducer,
  UserFormState,
} from '../externalApps/modules/customForm/reducer'
import {
  PrivateOffersInCreation,
  reducer as PrivateOffersCreation,
} from '../flyout/modules/privateOffer/privateOfferCreation/reducer'
import {
  resaleAuthorizationsCreationReducer as ResaleAuthorizationsCreation,
  type ResaleAuthorizationsInCreation,
  resellerReducer as ResellerReducer,
  type ResellerState,
  receivedResellerAuthorizationReducer as ReceivedResellerAuthorizationReducer,
  type ReceivedResellerAuthorizationState,
  storefrontReducer as StorefrontDataReducer,
  type StorefrontState,
  listingCardCreationReducer as ListingCardCreationReducer,
  type ListingCardInCreation,
  templateCreationReducer as TemplateCreationReducer,
  type TemplateInCreation,
  buttonCreationReducer as ButtonCreationReducer,
  type ButtonInCreation,
  storefrontMetricsReducer as StorefrontMetricsDataReducer,
  type MetricsData,
  flyoutRevenueInsightsReducer as RevenueInsightReducer,
  type FlyoutRevenueReportsData as ReportsData,
  revenueDisbursementSidePanelReducer as RevenueDisbursementPanelReducer,
  type RevenueDisbursementSidePanel,
  freeTrialsReducer as FreeTrialsReducer,
  type FreeTrialsState,
  combinedFormReducer as CombinedFormReducer,
  type CombinedFormState,
  contractsListingReducer as ContractsListingReducer,
  type ContractsListingState,
  flyoutOverviewReducer as OverviewReducer,
  type OverviewState,
  cppoResellerAgreementReducer as CPPOResellerAgreementReducer,
  type CPPOResellerAgreementState,
} from '@labrav/marketplace'
import {
  OtpState,
  reducer as OtpReducer,
} from '../externalApps/modules/otp/reducer'
import {
  IntegrationsState,
  reducer as IntegrationsReducer,
} from '../common/modules/thirdPartyAppIntegration/reducer'
import {
  SlackChannelsDataState,
  reducer as SlackChannelsReducer,
} from '../common/modules/slackChannels/reducer'
import {
  reducer as PlatformSettingsReducer,
  PlatformSettingsState,
} from '../common/modules/platformSettings/reducer'
import {
  reducer as CRMConfigurationReducer,
  CRMConfigurationState,
  PartnerCentralDetailsWithCloudProviders,
  zeroValuePartnerCentralDetails,
  zeroValueDefaultValues,
  DefaultValues,
} from '../oppsync/modules/CRMConfiguration/reducer'
import { arrayReducer, ArrayReducerRow } from '../common/modules/arrayReducer'
import {
  FlyOutListingData,
  reducer as FlyOutSyncs,
  MicrosoftFlyOutListingData,
  reducerMicrosoft as FlyOutSyncsMicrosoft,
} from '../admin/modules/flyOutSyncs/reducer'
import {
  productListingFilterReducer as ProductListingFiltersReducer,
  type ProductListingFilters,
} from '@labrav/marketplace'

import {
  flyOutOnboardingReducer as FlyOutOnboardingReducer,
  type FlyOutOnboarding,
} from '@labrav/marketplace'

import {
  reducer as WAFRAssessmentReducer,
  WAFRCreateAssessmentState,
} from '../cloudfaas/modules/wafrAssessment/reducer'

import {
  reducer as FTRAssessmentReducer,
  FTRCreateAssessmentState,
} from '../cloudfaas/modules/ftr/ftrAssessment/reducer'
import {
  answerReducer as AnswerReducer,
  AnswersState,
} from '../cloudfaas/modules/ftr/questionsList/reducer'
import {
  reducer as SectionsListingReducer,
  SectionsState,
} from '../cloudfaas/modules/ftr/sectionsList/reducer'
import {
  reducer as QuestionsListingReducer,
  QuestionsState,
} from '../cloudfaas/modules/ftr/questionsList/reducer'
import {
  reducer as WAFRPillarWorkloadReducer,
  PillarWorkloadState,
} from '../cloudfaas/modules/wafrPillars/reducer'

import {
  reducer as FTRFindingsReducer,
  FTRFindingsState,
} from '../cloudfaas/modules/ftr/FTRFindings/reducer'

import type {
  ProductInCreation,
  FlyOutMigrationProductsInfo,
} from '@labrav/marketplace'

import {
  reducer as AutoSaveReducer,
  AutoSaveState,
} from '../common/modules/autoSave/reducer'
import {
  CloudAccountState,
  reducer as CloudAccountReducer,
} from '../common/modules/CloudAccounts/reducer'
import {
  subscriptionsReducer as SubscriptionsReducer,
  type SubscriptionsState,
} from '@labrav/marketplace'
import {
  reducer as CoSellReducer,
  CoSellState,
} from '../oppsync/modules/CoSell/reducer'
import {
  reducer as PartnerIQReducer,
  PartnerIQState,
} from '../oppsync/modules/PartnerIQ/reducer'
import {
  reducer as ReferralFormCreationReducer,
  ReferralForm,
} from '../oppsync/modules/CoSell/ReferralForm/reducer'
import {
  reducer as ReferralLeadFormReducer,
  ReferralForm as LeadReferralForm,
} from '../oppsync/modules/CoSell/LeadsReferralForm/reducer'
import {
  reducer as AzureReferralFormReducer,
  ReferralForm as AzureReferralForm,
} from '../oppsync/modules/CoSell/AzureReferralForm/reducer'
import {
  FTRReviewInCreation,
  reducer as CloudfaasFTRReviewInCreationReducer,
} from '../cloudfaas/modules/assessementForm/reducer'
import {
  Customer,
  reducer as NewCustomers,
} from '../admin/modules/NewCustomers/reducer'
import {
  reducer as MarketplaceSeoReducer,
  MpsSeoState,
} from '../common/modules/mpsSeo/reducer'
import {
  reducer as WAFRQuestionAnswerReducer,
  WAFRQuestionAnswerState,
} from '../../src/cloudfaas/modules/wafrQuestionAnswerDetails/reducer'
import {
  reducer as AwsAccountsReducer,
  AwsAccountState,
} from '../cloudfaas/modules/wafrCreateAssessment/reducer'
import {
  reducer as AssessmentsListingReducer,
  AssessmentsState,
} from '../cloudfaas/modules/ftr/assessementList/reducer'

import { reducer as WorkloadReducer } from '../cloudfaas/modules/workloadList/reducer'

import { reducer as CloudFaasReducer } from '../cloudfaas/modules/cloudFaasOnboarding/reducer'

import {
  reducer as propensityReducer,
  PropensityData,
} from '../oppsync/modules/Propensity/reducer'
import {
  reducer as smartGtmReducer,
  SmartGtmData,
} from '../oppsync/modules/SmartGtm/reducer'

import {
  reducer as CoSellMappingManagerReducer,
  CoSellMappingManagerData,
} from '../oppsync/modules/coSellMappingManager/reducer'
import {
  channelPartnerPrivateOffersReducer as ChannelPartnerPrivateOffersReducer,
  type ChannelPartnerPrivateOffersState,
} from '@labrav/marketplace'

import {
  engineServicePartnerReducer,
  EngineServicePartnerState,
} from '../oppsync/modules/engineServicePartner/reducer'
import {
  modalSubscriptionReducer as ModalSubscriptionReducer,
  type ModalSubscriptionsState,
} from '@labrav/marketplace'

import {
  apiKeysReducer,
  APIKeysState,
} from '../oppsync/modules/userList/reducer'
import {
  reducer as ShareWorkloadReducer,
  ShareWorkloadState,
} from '../cloudfaas/modules/wafrShareWorkload/reducer'
import {
  reducer as WorkloadShareListReducer,
  WorkloadShareListState,
} from '../cloudfaas/modules/wafrSharedWorkloadList/reducer'

import {
  crmAuditLogsReducer,
  CrmAuditLogsState,
} from '../admin/modules/crmAuditLogs/reducer'

import {
  auditLogsReducer,
  AuditLogsState,
} from '../oppsync/modules/userList/reducer'

import {
  marketplaceMappingManagerReducer as MarketplaceMappingManagerReducer,
  type MarketplaceMappingManagerData,
} from '@labrav/marketplace'
import {
  reducer as TenantsReducer,
  TenantsDataState,
} from '../common/modules/tenant/reducer'
import { reducer as AccountSelectionReducer } from '../common/modules/accountSelection/reducer'
import { AccountSelectionState } from '../common/modules/accountSelection/types'
import {
  MsftCombinedFormState,
  microsoftCombinedFormReducer as MicrosoftCombinedFormReducer,
} from '@labrav/marketplace'
import { reducer as AllIcpDataReducer } from '../oppsync/modules/AllIcps/reducer'
import { labraChatReducer, type LabraChatState } from '@labrav/common'
import {
  reducer as fundingSummaryReducer,
  FundingSummaryState,
} from '../oppsync/modules/FundingSummary/reducer'
import { reducer as teamRelationshipReducer } from '../oppsync/modules/teamRelationship/reducer'
import { TeamRelationshipState } from '../oppsync/modules/teamRelationship/types'

// When adding more reducers with state, just add them here with intersections
// https://stackoverflow.com/a/27326935
// RootState = CounterState & AuthState & ScrollState

export type AppState = {
  faqDrawer: FaqDrawerState
  crmSelector: CRMListState
  appAlert: AppAlertState
  savedStatus: SavedStatus
  CRMAuth: CRMAuthState
  chartsData: DashBoardChartsState
  AccountData: {
    user: AccountDataState
    admin: AccountDataState
  }
  partnerStats: PartnerObjectsStatsState
  partnerObject: {
    leadsData: PartnerObjectsState
    opportunitiesData: PartnerObjectsState
  }
  syncObject: SyncObjectState
  AllPartners: AllPartnerState
  crmAceMapping: {
    lead: CrmAceMappingState
    opportunity: CrmAceMappingState
  }
  validationCrmAceMappingKey: {
    lead: Validate
    opportunity: Validate
  }
  defaultValueValidation: {
    lead: DefaultValueState
    opportunity: DefaultValueState
  }
  ruleDefinition: {
    lead: RuleDefinitionMappingState
    opportunity: RuleDefinitionMappingState
  }
  syncHistory: SyncHistoryState
  syncReport: SyncReportState
  onboardingVerification: OnboardingVerificationState
  showSupportForm: SupportFormState
  userProfile: UserProfileState
  authorization: AuthorizationState
  subscription: SubscriptionState
  userList: {
    user: UserListState
    admin: UserListState
  }
  addNewUsers: {
    metadata: AddNewUsersState
    users: ArrayReducerRow<UserType>[]
  }
  crmTables: CrmTableState
  crmSchema: CRMSchemaState
  crmFields: CrmFieldReducerState
  crmTableFieldsLoading: CRMTableFieldLoadingState
  CRMConfiguration: {
    metadata: CRMConfigurationState
    partnerCentralDetails: PartnerCentralDetailsWithCloudProviders
    defaultValues: ArrayReducerRow<DefaultValues>[]
  }
  notificationSidePanel: NotificationPanelState
  notifications: {
    oppsync: NotificationsState
    flyout: NotificationsState
    cloudfaas: NotificationsState
    funding: NotificationsState
  }
  warningStatus: {
    lead: WarningState
    opportunity: WarningState
  }
  productListingFilters: ProductListingFilters
  productsListing: {
    AWS: ProductsListingState
    AZURE: ProductsListingState
    GCP: ProductsListingState
    REDHAT: ProductsListingState
  }

  marketplaceSeo: {
    AWS: MpsSeoState
    AZURE: MpsSeoState
    GCP: MpsSeoState
    REDHAT: MpsSeoState
  }

  accountForm: {
    oppsync: AccountsState
    flyout: AccountsState
    cloudfaas: AccountsState
  }

  accounts: {
    oppsync: CmcmAccountState
    flyout: CmcmAccountState
    cloudfaas: CmcmAccountState
  }
  contractsListing: ContractsListingState
  privateOffers: PrivateOffersState
  flyoutOverview: OverviewState
  freeTrials: FreeTrialsState

  customForm: {
    hubspotForm: UserFormState
  }
  otp: OtpState
  cppoReseller: ResaleAuthorizationsState
  receivedResellerAuthorization: ReceivedResellerAuthorizationState
  channelPartnerPrivateOffers: ChannelPartnerPrivateOffersState
  revenueInsights: {
    daily: ReportsData
    monthly: ReportsData
    disbursement: ReportsData
    cloudDisbursement: ReportsData
  }
  revenueDisbursementSidePanel: RevenueDisbursementSidePanel
  templateCreation: TemplateInCreation
  propensity: PropensityData
  coSellMappingManager: CoSellMappingManagerData
  marketplaceMappingManager: MarketplaceMappingManagerData
  privateOffersInCreation: PrivateOffersInCreation
  cppoResellerAgreement: Partial<CPPOResellerAgreementState>
  integrations: IntegrationsState
  slackChannels: {
    oppsync: SlackChannelsDataState
    flyout: SlackChannelsDataState
    cloudfaas: SlackChannelsDataState
    funding: SlackChannelsDataState
  }
  listingCardInCreation: ListingCardInCreation
  platformSettings: PlatformSettingsState
  resaleAuthorizationsInCreation: ResaleAuthorizationsInCreation
  resellers: ResellerState
  flyoutSellerInfo: FlyOutListingData
  flyOutSellerInfoMicrosoft: MicrosoftFlyOutListingData
  flyOutOnboarding: FlyOutOnboarding
  flyOutMigrationProductsInfo: FlyOutMigrationProductsInfo
  autoSave: AutoSaveState

  cloudAccounts: {
    oppsync: CloudAccountState
    flyout: CloudAccountState
    cloudfaas: CloudAccountState
  }
  subscriptions: SubscriptionsState
  engineServicePartner: EngineServicePartnerState
  CoSell: {
    oppsync: CoSellState
    flyout: CoSellState
    cloudfaas: CoSellState
  }
  referralFormCreation: ReferralForm
  leadReferralForm: LeadReferralForm
  azureReferralForm: AzureReferralForm
  flyoutProductInCreation: ProductInCreation
  cloudfaasFTRReviewInCreation: FTRReviewInCreation
  newCustomerCreation: Customer
  storefrontData: StorefrontState
  wafrQuestionAnswerReducer: WAFRQuestionAnswerState
  storefrontMetricsData: MetricsData
  awsAccountsReducer: AwsAccountState
  wafrCreateAssessmentReducer: WAFRCreateAssessmentState
  ftrCreateAssessmentReducer: FTRCreateAssessmentState
  ftrAnnswerReducer: AnswersState
  ftrSectionsReducer: SectionsState
  ftrQuestionsReducer: QuestionsState
  pillarWorkloadReducer: PillarWorkloadState
  ftrFindingsReducer: FTRFindingsState
  buttonCreation: ButtonInCreation
  modalSubscription: ModalSubscriptionsState
  apiKeys: APIKeysState
  shareWorkload: ShareWorkloadState
  shareWorkloadList: WorkloadShareListState

  auditLogs: AuditLogsState
  crmAuditLogs: CrmAuditLogsState
  assessmentsReducer: AssessmentsState
  tenants: TenantsDataState
  accountSelection: AccountSelectionState
  combinedFormInCreation: CombinedFormState
  microsoftCombinedForm: MsftCombinedFormState
  smartGtm: SmartGtmData
  partnerIQ: PartnerIQState
  labraChat: LabraChatState
  fundingSummary: FundingSummaryState
  teamRelationship: TeamRelationshipState
}

export const appReducerMap = {
  faqDrawer: faqDrawerReducer,
  crmSelector: crmSelectorReducer,
  appAlert: AlertReducer,
  savedStatus: SavedReducer,
  CRMAuth: CRMAuthReducer,

  AccountData: combineReducers({
    user: reducerTypeWrapper('user', PartnerReducer),
    admin: reducerTypeWrapper('admin', PartnerReducer),
  }),
  chartsData: chartReducer,
  partnerStats: PartnerStatsReducer,
  partnerObject: combineReducers({
    leadsData: reducerTypeWrapper('lead', PartnerObjectsReducer),
    opportunitiesData: reducerTypeWrapper('opportunity', PartnerObjectsReducer),
  }),
  syncObject: SyncObjectReducer,
  crmAceMapping: combineReducers({
    lead: reducerTypeWrapper('lead', CrmAceMappingReducer),
    opportunity: reducerTypeWrapper('opportunity', CrmAceMappingReducer),
  }),
  validationCrmAceMappingKey: combineReducers({
    lead: reducerTypeWrapper('lead', validateReducer),
    opportunity: reducerTypeWrapper('opportunity', validateReducer),
  }),
  defaultValueValidation: combineReducers({
    lead: reducerTypeWrapper('lead', defaultValueValidationReducer),
    opportunity: reducerTypeWrapper(
      'opportunity',
      defaultValueValidationReducer
    ),
  }),
  ruleDefinition: combineReducers({
    lead: reducerTypeWrapper('lead', RuleDefinition),
    opportunity: reducerTypeWrapper('opportunity', RuleDefinition),
  }),
  syncHistory: SyncHistoryReducer,
  showSupportForm: SupportFormReducer,
  AllPartners: AllPartnersReducer,
  userProfile: UserProfileReducer,
  authorization: AuthorizationReducer,
  subscription: SubscriptionReducer,
  syncReport: SyncReportReducer,
  userList: combineReducers({
    user: reducerTypeWrapper('user', UserListReducer),
    admin: reducerTypeWrapper('admin', UserListReducer),
  }),
  addNewUsers: combineReducers({
    users: reducerTypeWrapper(
      'addNewUsers',
      arrayReducer(zeroValueAddUserForm)
    ),
    metadata: AddUsersReducer,
  }),
  crmTables: CrmTablesReducer,
  crmSchema: CRMSchemaReducer,
  crmFields: CrmFieldReducer,
  crmTableFieldsLoading: CRMTableFieldsLoading,
  CRMConfiguration: combineReducers({
    partnerCentralDetails: combineReducers({
      AWS: reducerTypeWrapper(
        'awsPartnerCentralUsersDetails',
        arrayReducer(zeroValuePartnerCentralDetails)
      ),
      AZURE: reducerTypeWrapper(
        'azurePartnerCentralUsersDetails',
        arrayReducer(zeroValuePartnerCentralDetails)
      ),
      GCP: reducerTypeWrapper(
        'gcpPartnerCentralUsersDetails',
        arrayReducer(zeroValuePartnerCentralDetails)
      ),
      REDHAT: reducerTypeWrapper(
        'redhatPartnerCentralUsersDetails',
        arrayReducer(zeroValuePartnerCentralDetails)
      ),
    }),
    metadata: CRMConfigurationReducer,
    defaultValues: reducerTypeWrapper(
      'defaultValues',
      arrayReducer(zeroValueDefaultValues)
    ),
  }),
  notificationSidePanel: NotificationSidePanelReducer,
  notifications: combineReducers({
    oppsync: reducerTypeWrapper('oppsync', NotificationsReducer),
    flyout: reducerTypeWrapper('flyout', NotificationsReducer),
    cloudfaas: reducerTypeWrapper('cloudfaas', NotificationsReducer),
    funding: reducerTypeWrapper('funding', NotificationsReducer),
  }),
  warningStatus: combineReducers({
    lead: reducerTypeWrapper('lead', WarningStatusReducer),
    opportunity: reducerTypeWrapper('opportunity', WarningStatusReducer),
  }),
  productsListing: combineReducers({
    AWS: reducerTypeWrapper('AWS', ProductsListingReducer),
    AZURE: reducerTypeWrapper('AZURE', ProductsListingReducer),
    GCP: reducerTypeWrapper('GCP', ProductsListingReducer),
    REDHAT: reducerTypeWrapper('REDHAT', ProductsListingReducer),
  }),
  assessmentsReducer: AssessmentsListingReducer,
  workloadReducer: WorkloadReducer,
  accountForm: combineReducers({
    oppsync: reducerTypeWrapper('oppsync', AccountsStateReducer),
    flyout: reducerTypeWrapper('flyout', AccountsStateReducer),
    cloudfaas: reducerTypeWrapper('cloudfaas', AccountsStateReducer),
  }),
  accounts: combineReducers({
    oppsync: reducerTypeWrapper('oppsync', AccountsReducer),
    flyout: reducerTypeWrapper('flyout', AccountsReducer),
    cloudfaas: reducerTypeWrapper('cloudfaas', AccountsReducer),
  }),

  contractsListing: ContractsListingReducer,
  privateOffers: PrivateOffersReducer,
  flyoutOverview: OverviewReducer,
  freeTrials: FreeTrialsReducer,
  customForm: combineReducers({
    hubspotForm: reducerTypeWrapper('hubspotForm', CustomFormReducer),
  }),
  otp: OtpReducer,
  cppoReseller: CPPOAdminReducer,
  receivedResellerAuthorization: ReceivedResellerAuthorizationReducer,
  channelPartnerPrivateOffers: ChannelPartnerPrivateOffersReducer,
  revenueInsights: combineReducers({
    daily: reducerTypeWrapper('daily', RevenueInsightReducer),
    monthly: reducerTypeWrapper('monthly', RevenueInsightReducer),
    cloudDisbursement: reducerTypeWrapper(
      'cloudDisbursement',
      RevenueInsightReducer
    ),
    disbursement: reducerTypeWrapper('disbursement', RevenueInsightReducer),
  }),
  revenueDisbursementSidePanel: RevenueDisbursementPanelReducer,
  privateOffersInCreation: PrivateOffersCreation,
  cppoResellerAgreement: CPPOResellerAgreementReducer,
  integrations: IntegrationsReducer,
  slackChannels: combineReducers({
    oppsync: reducerTypeWrapper('oppsync', SlackChannelsReducer),
    flyout: reducerTypeWrapper('flyout', SlackChannelsReducer),
    cloudfaas: reducerTypeWrapper('cloudfaas', SlackChannelsReducer),
    funding: reducerTypeWrapper('funding', SlackChannelsReducer),
  }),
  platformSettings: PlatformSettingsReducer,
  resaleAuthorizationsInCreation: ResaleAuthorizationsCreation,
  resellers: ResellerReducer,
  flyoutSellerInfo: FlyOutSyncs,
  flyOutSellerInfoMicrosoft: FlyOutSyncsMicrosoft,
  productListingFilters: ProductListingFiltersReducer,
  flyOutOnboarding: FlyOutOnboardingReducer,
  wafrCreateAssessmentReducer: WAFRAssessmentReducer,
  pillarWorkloadReducer: WAFRPillarWorkloadReducer,
  ftrFindingsReducer: FTRFindingsReducer,
  ftrCreateAssessmentReducer: FTRAssessmentReducer,
  ftrAnnswerReducer: AnswerReducer,
  ftrSectionsReducer: SectionsListingReducer,
  ftrQuestionsReducer: QuestionsListingReducer,
  autoSave: AutoSaveReducer,
  cloudAccounts: combineReducers({
    oppsync: reducerTypeWrapper('oppsync', CloudAccountReducer),
    flyout: reducerTypeWrapper('flyout', CloudAccountReducer),
    cloudfaas: reducerTypeWrapper('cloudfaas', CloudAccountReducer),
  }),
  subscriptions: SubscriptionsReducer,
  cosell: combineReducers({
    oppsync: reducerTypeWrapper('oppsync', CoSellReducer),
    flyout: reducerTypeWrapper('flyout', CoSellReducer),
    cloudfaas: reducerTypeWrapper('cloudfaas', CoSellReducer),
  }),
  referralFormCreation: ReferralFormCreationReducer,
  leadReferralForm: ReferralLeadFormReducer,
  azureReferralForm: AzureReferralFormReducer,
  cloudfaasFTRReviewInCreation: CloudfaasFTRReviewInCreationReducer,
  newCustomerCreation: NewCustomers,
  marketplaceSeo: combineReducers({
    AWS: reducerTypeWrapper('AWS', MarketplaceSeoReducer),
    AZURE: reducerTypeWrapper('AZURE', MarketplaceSeoReducer),
    GCP: reducerTypeWrapper('GCP', MarketplaceSeoReducer),
    REDHAT: reducerTypeWrapper('REDHAT', MarketplaceSeoReducer),
  }),
  templateCreation: TemplateCreationReducer,
  listingCardInCreation: ListingCardCreationReducer,
  storefrontData: StorefrontDataReducer,
  wafrQuestionAnswerReducer: WAFRQuestionAnswerReducer,
  cloudFaasOnboardingReducer: CloudFaasReducer,
  propensity: propensityReducer,
  coSellMappingManager: CoSellMappingManagerReducer,
  marketplaceMappingManager: MarketplaceMappingManagerReducer,
  storefrontMetricsData: StorefrontMetricsDataReducer,
  awsAccountsReducer: AwsAccountsReducer,
  buttonCreation: ButtonCreationReducer,
  engineServicePartner: combineReducers({
    admin: reducerTypeWrapper('admin', engineServicePartnerReducer),
    user: reducerTypeWrapper('user', engineServicePartnerReducer),
  }),
  modalSubscription: ModalSubscriptionReducer,
  apiKeys: apiKeysReducer,
  shareWorkload: ShareWorkloadReducer,
  shareWorkloadList: WorkloadShareListReducer,
  auditLogs: auditLogsReducer,
  crmAuditLogs: crmAuditLogsReducer,
  tenants: TenantsReducer,
  accountSelection: AccountSelectionReducer,
  combinedFormInCreation: CombinedFormReducer,
  microsoftCombinedForm: MicrosoftCombinedFormReducer,
  smartGtm: smartGtmReducer,
  partnerIQ: PartnerIQReducer,
  allIcpData: AllIcpDataReducer,
  onboardingVerification: onboardingVerificationReducer,
  labraChat: labraChatReducer,
  fundingSummary: fundingSummaryReducer,
  teamRelationship: teamRelationshipReducer,
}

export const rootReducer = combineReducers(appReducerMap)
